"use client"

import "./static-timer.css"
import { Clock } from 'lucide-react'

const StaticTimerPill = ({ minutes = 10, seconds = 0, className = "" }) => {
  // Format the time string
  const timeString = seconds > 0 ? `${minutes}:${seconds.toString().padStart(2, "0")} minuten` : `${minutes} minuten`

  return (
    <div className={`static-timer-pill ${className}`}>
      <Clock size={18} className="timer-icon" />
      <span className="timer-text">{timeString}</span>
    </div>
  )
}

export default StaticTimerPill
